import { render, staticRenderFns } from "./TransactionDetail.vue?vue&type=template&id=16e7e7e9&scoped=true&"
import script from "./TransactionDetail.vue?vue&type=script&lang=js&"
export * from "./TransactionDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransactionDetail.vue?vue&type=style&index=0&id=16e7e7e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e7e7e9",
  null
  
)

export default component.exports